import { ModalWindow } from '@cian/ui-kit/modal';
import * as React from 'react';

import { CreditInfoModalContent } from 'shared/components/CreditInfoModalContent';
import { Button } from '@cian/ui-kit';
import { useCreditInfoModal } from 'shared/hooks/useCreditInfoModal';

export const CreditInfoModalContainer: React.FC = () => {
  const { isModalOpen, handleModalClose, modalContent } = useCreditInfoModal();

  return (
    <ModalWindow
      open={isModalOpen}
      content={<CreditInfoModalContent creditInfo={modalContent} />}
      footer={<Button onClick={handleModalClose}>Понятно</Button>}
      onClose={handleModalClose}
      fixed
      width={880}
      size="XS"
      title="Все условия кредита"
    />
  );
};
